import React from 'react';

const Camping = () => {
  return (
<div className="container mt-5 pt-3">
      {/* Section 1: Bootstrap Carousel */}
      <div id="senderismoCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-inner rounded shadow">
          <div className="carousel-item active">
            <img src="/camping.jpeg" className="d-block w-100" alt="Eco Cabaña" style={{height: '600px', objectFit: 'cover'}} />
          </div>
        </div>
      </div>
      
      {/* Section 2: Title and Description */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">Camping</h1>
          <p className="lead mb-5 text-start">Ubicado en el corazón de la naturaleza, Casa Origen Ecohotel ofrece una experiencia de camping incomparable, donde el contacto con el medio ambiente y la tranquilidad son los protagonistas. Este refugio ecológico, rodeado de paisajes impresionantes, invita a los aventureros a sumergirse en la belleza natural de la región mientras disfrutan de todas las comodidades, logrando que tu experiencia de sea una oportunidad para desconectar del ruido del mundo moderno y reconectar con la magia de lo naturaleza. 
          <br/>Este tipo de camping no sólo ofrece una experiencia inmersiva en la naturaleza, sino que también contribuye a la conservación del ecosistema, ayudando a preservar el entorno local para las futuras generaciones.</p>
        </div>
      </div>
    </div>
  );
};

export default Camping;